// Refs for highlighting
import {ref} from "vue";

export function useTableHighlight() {
    const hoveredRow = ref(null);
    const hoveredCol = ref(null);

// Methods to set and clear hovered states
    const setHoveredRow = (rowIndex: number): void => {
        hoveredRow.value = rowIndex;
    };

    const setHoveredCol = (colIndex: number): void => {
        hoveredCol.value = colIndex;
    };

    const clearHoveredRow = () => {
        hoveredRow.value = null;
    };

    const clearHoveredCol = () => {
        hoveredCol.value = null;
    };

    const isRowHovered = (rowIndex: number): boolean => {
        return hoveredRow.value === rowIndex;
    };

    const isColHovered = (colIndex: number): boolean => {
        return hoveredCol.value === colIndex;
    };

    return {
        hoveredRow,
        hoveredCol,
        setHoveredRow,
        setHoveredCol,
        clearHoveredRow,
        clearHoveredCol,
        isRowHovered,
        isColHovered
    }
}